/**
 * @generated SignedSource<<450562b106a333788a034b95fdc20759>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateOrSaveUserInput = {
  clientMutationId?: string | null | undefined;
  defaultAccount?: string | null | undefined;
  firstName: string;
  isTransporter: boolean;
  lastName: string;
  mobilePhone: string;
  preferences?: UserPreferencesInput | null | undefined;
  preferredStates?: ReadonlyArray<string | null | undefined> | null | undefined;
  receiveEmails?: boolean | null | undefined;
  rego?: string | null | undefined;
  signature?: string | null | undefined;
  termsAccepted?: boolean | null | undefined;
};
export type UserPreferencesInput = {
  notifications?: NotificationPreferenceInput | null | undefined;
};
export type NotificationPreferenceInput = {
  receiveUnlockEmail?: boolean | null | undefined;
  receiveUnlockSms?: boolean | null | undefined;
};
export type createOrSaveUserMutation$variables = {
  input: CreateOrSaveUserInput;
};
export type createOrSaveUserMutation$data = {
  readonly createOrSaveUser: {
    readonly data: {
      readonly accounts: ReadonlyArray<{
        readonly accountId: string | null | undefined;
        readonly accountLabel: string | null | undefined;
        readonly accountType: string | null | undefined;
        readonly email: string | null | undefined;
        readonly envdAccountId: string | null | undefined;
        readonly properties: {
          readonly accreditations: {
            readonly eU: boolean;
            readonly eUGFHQB: boolean;
            readonly lPA: boolean;
            readonly mSA: boolean;
            readonly nFAS: boolean;
          } | null | undefined;
          readonly address: {
            readonly line1: string | null | undefined;
            readonly postcode: string | null | undefined;
            readonly state: string | null | undefined;
            readonly town: string | null | undefined;
          } | null | undefined;
          readonly entityName: string | null | undefined;
          readonly firstName: string | null | undefined;
          readonly lastName: string | null | undefined;
          readonly msaMemberNum: string | null | undefined;
          readonly nameId: string | null | undefined;
          readonly nlisAccountId: string | null | undefined;
          readonly nlisAccountType: string | null | undefined;
          readonly nlisUserId: string | null | undefined;
          readonly propertyName: string | null | undefined;
          readonly reAccreditationDate: string | null | undefined;
          readonly rego: string | null | undefined;
        } | null | undefined;
        readonly roles: ReadonlyArray<string | null | undefined> | null | undefined;
      } | null | undefined>;
      readonly defaultAccount: string;
      readonly email: string;
      readonly firstName: string;
      readonly isNewUser: boolean;
      readonly lastName: string;
      readonly mobilePhone: string;
      readonly preferences: {
        readonly notifications: {
          readonly receiveUnlockEmail: boolean | null | undefined;
          readonly receiveUnlockSms: boolean | null | undefined;
        } | null | undefined;
      } | null | undefined;
      readonly receiveEmails: boolean;
      readonly signature: string;
      readonly termsAccepted: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type createOrSaveUserMutation = {
  response: createOrSaveUserMutation$data;
  variables: createOrSaveUserMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateOrSaveUser",
    "kind": "LinkedField",
    "name": "createOrSaveUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserDetailType",
        "kind": "LinkedField",
        "name": "data",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "mobilePhone",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isNewUser",
            "storageKey": null
          },
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "defaultAccount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "receiveEmails",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "signature",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "termsAccepted",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserPreferencesType",
            "kind": "LinkedField",
            "name": "preferences",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "NotificationPreferenceType",
                "kind": "LinkedField",
                "name": "notifications",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "receiveUnlockEmail",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "receiveUnlockSms",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "accounts",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "envdAccountId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "accountType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "accountLabel",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "accountId",
                "storageKey": null
              },
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountProperties",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nameId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nlisAccountId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nlisUserId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nlisAccountType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "rego",
                    "storageKey": null
                  },
                  (v1/*: any*/),
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "entityName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "propertyName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "msaMemberNum",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "reAccreditationDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AccountAddress",
                    "kind": "LinkedField",
                    "name": "address",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "line1",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "town",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "state",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "postcode",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ClaimAccreditations",
                    "kind": "LinkedField",
                    "name": "accreditations",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lPA",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "eU",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "mSA",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "eUGFHQB",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "nFAS",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "roles",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createOrSaveUserMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createOrSaveUserMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "b874fdc5338c3cb235bddfbdececda12",
    "id": null,
    "metadata": {},
    "name": "createOrSaveUserMutation",
    "operationKind": "mutation",
    "text": "mutation createOrSaveUserMutation(\n  $input: CreateOrSaveUserInput!\n) {\n  createOrSaveUser(input: $input) {\n    data {\n      firstName\n      lastName\n      mobilePhone\n      isNewUser\n      email\n      defaultAccount\n      receiveEmails\n      signature\n      termsAccepted\n      preferences {\n        notifications {\n          receiveUnlockEmail\n          receiveUnlockSms\n        }\n      }\n      accounts {\n        envdAccountId\n        accountType\n        accountLabel\n        accountId\n        email\n        properties {\n          nameId\n          nlisAccountId\n          nlisUserId\n          nlisAccountType\n          rego\n          firstName\n          lastName\n          entityName\n          propertyName\n          msaMemberNum\n          reAccreditationDate\n          address {\n            line1\n            town\n            state\n            postcode\n          }\n          accreditations {\n            lPA\n            eU\n            mSA\n            eUGFHQB\n            nFAS\n          }\n        }\n        roles\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5a30b778054a2af7c7061991fa5c7425";

export default node;
